<template>
<div class="chapter">
<div class="inner_page">
<div id="OldFlames_epub-2.html" xml:lang="en-US">
<div class="story">
<p class="CT-new-page para-style-override-1"><span class="Section-Symbol char-style-override-3">O</span><span class="char-style-override-3">LD</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-4">FLAMES</span></p>
<p class="BT-1st-Para para-style-override-3"><span class="char-style-override-5">John Lawton</span></p>
<p class="BT-1st-Para para-style-override-4"><img alt="V-1.tif" class="image" height="30" src="images/V-1_fmt.png" width="33"/></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-6">Grove Press</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-7">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OldFlames_epub2.vue?5a112b83